import React, { useState, useContext, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";
import {localizeKey, localizeArt} from './../localize.js';
import axiosInstance from './../axiosInstance.js';
import MyUserContext from './../myUserContext.js';
import Collapsible from './Collapsible';
import MyChatComponent from './MyChatComponent';
import ShareButton from './ShareButton';
import CopyTextButton from './CopyTextButton';
import TagsInput from './TagsInput';
import PeopleTags from './PeopleTags';
import { Link, useNavigate } from 'react-router-dom';
import PlatformRatings from './PlatformRatings.js';

// TODO: get rid of isDropdown, it's always false
// eventType: like, /*recommendationIncoming, recommendationOutgoing,*/ recommendation
const CardEventArtChat = ({ event, eventType, art, chatInfo, language, userName, userInfo, misc, chatState, isDropdown=false, chatFillHeight=false }) => {
  const myUser = useContext(MyUserContext);
  const navigate = useNavigate();

  const artLink = art.wikiArticleLink;
  const hostnameParts = new URL(artLink).hostname.split('.');
  const secondLevelDomain = hostnameParts[1];
  let iconFile = "/wiki_icon.png";
  if (secondLevelDomain === 'steampowered') {
    iconFile = "/steam_icon.png";
  } else if (secondLevelDomain == 'imdb') {
    iconFile = "/imdb_icon.png"
  } else if (secondLevelDomain == 'apple') {
    iconFile = "/applebooks_icon.png"
  }

  const elementRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
        }
      },
      {
        threshold: 0.1, // Adjust the threshold as needed
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const element = elementRef.current;
    if (element) {
      element.style.overflow = 'hidden'; // Disable scroll for the main component
    }
    return () => {
      if (element) {
        element.style.overflow = ''; // Reset overflow on cleanup
      }
    };
  }, []);

  const [eventId, setEventId] = useState(event.id);
  const [eventTags, setEventTags] = useState(event.eventTags);
  const [eventChatId, setEventChatId] = useState(event.chatId);
  const [eventChatInfo, setEventChatInfo] = useState(chatInfo);

  const [removed, setRemoved] = useState(false);
  const handleEventRemove = (eventId) => {
    axiosInstance
    .delete(`/artEvents/${eventId}`)
    .then((response) => {
      alert("Removed / Удалено");
    })
    .catch((error) => {
      console.error(error);
    })
  }

  const handleEventTag = (eventId, inputTagNames) => {
    axiosInstance
    .post(`/artEvents/tag/${eventId}/tag`, { tags: inputTagNames })
    .then((response) => {
      setEventTags(response.data.event.eventTags);
    })
    .catch((error) => {
      console.error(error);
    })
  }

  const [pinned, setPinned] = useState(event.pinned);
  const handleEventPin = (eventId) => {
    axiosInstance
    .post(`/artEvents/pin/${eventId}/pin`)
    .then((response) => {
      setPinned(true);
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 406) {
          alert(localizeKey('pinsLimitReached', language));
        } else {
          console.error(error);
        }
      } else {
        console.error(error);
      }
    })
  }
  const handleEventUnpin = (eventId) => {
    axiosInstance
    .delete(`/artEvents/pin/${eventId}/pin`)
    .then((response) => {
      setPinned(false);
    })
    .catch((error) => {
      console.error(error);
    })
  }

  const isRecommendation = eventType.includes('recommendation');
  const [selectedRecommendationUserTag, setSelectedRecommendationUserTag] = useState(
    isRecommendation ? event.eventTags?.[0] || null : null
  );
  useEffect(() => {
    if (!isRecommendation) {
      return;
    }
    if (!selectedRecommendationUserTag && eventTags && eventTags.length > 0) {
      setSelectedRecommendationUserTag(eventTags[0]);
    }
  }, [isRecommendation, eventTags, selectedRecommendationUserTag]);
  const updatePersonalRecomChatId = (selectedTag) => {
    console.log("selected tag", selectedTag);
    if (!selectedTag) {
      return;
    }
    if (selectedRecommendationUserTag && selectedTag.id === selectedRecommendationUserTag.id) {
      return; // no need to request from backend
    }
    axiosInstance
    .get(`/artEvents/${eventId}?recommendationUserId=${selectedTag.creatorUser}`)
    .then((response) => {
      if (response.data.event.chatId === eventChatId) { // something went wrong, same chat returned for different user
        console.error("same private chat returned for different user");
        return;
      }
      setEventChatId(response.data.event.chatId);
      setSelectedRecommendationUserTag(selectedTag);
      setEventChatInfo(response.data.chat);
    })
    .catch((error) => {
      console.error(error);
    })
  }

  // const recomNotFinished = eventType === "recommendation" && art.myEventType !== "like" && art.myEventType !== "finished";
  let outerClassModification = "";
  // if (false && removed) { // todo: refactor
  //   outerClassModification = "pointer-events-none grayscale";
  // } else if (recomNotFinished) {
  //   outerClassModification = "border border-blue-400 rounded-lg shadow outline-1";
  // }

  const queryParams = new URLSearchParams(window.location.search);
  const tagsInitFocus = queryParams.get('tagsInitFocus') === 'true';

  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [isLogbookModalVisible, setIsLogbookModalVisible] = useState(false);

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const handleDropdownAction = (action) => {
    if (action === 'pin') {
      if (pinned) {
        handleEventUnpin(eventId);
      } else {
        handleEventPin(eventId);
      }
    } else if (action === 'remove') {
      if (window.confirm(language === "ru" ? "Вы уверены, что хотите удалить произведение из своей библиотеки?" : "Are you sure you want to remove the art from your library?")) {
        handleEventRemove(eventId);
      }
    } else if (action === 'logbook') {
      navigate(`/logbook?artEventId=${event.id}`);
    }
    setDropdownVisible(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownVisible && !event.target.closest('.dropdown-container')) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownVisible]);

  const logbookDateTime = event.logbookDateTimes && event.logbookDateTimes.length > 0 ? new Date(event.logbookDateTimes[0]) : null;

  const chatComponentRef = useRef(null); // Ref for MyChatComponent

  useEffect(() => {
    if (chatState !== "hidden" && chatComponentRef.current) {
      chatComponentRef.current.focus(); // Focus on MyChatComponent when opened
    }
  }, [chatState]);

  return (
    <>
      <div
        ref={elementRef}
        class={
          (outerClassModification !== "" ? outerClassModification + " " : "") +
          "mx-auto max-w-xl" +
          (chatFillHeight ? " flex h-full flex-col min-h-0" : "")
        }
      >
        <div class={chatFillHeight ? "shrink-0" : ""}>
        {!isDropdown &&
        <div class="text-sm md:text-base mt-2 mx-2 md:ml-1">
          <div class="flex justify-end items-center">
            {pinned && (
              <div class="text-2xl mr-2">
                📌
              </div>
            )}
            {(myUser && myUser.myUserInfo.myUserId === event.userID) && (
              <div class="relative dropdown-container">
                <div
                  class="cursor-pointer text-xl"
                  onClick={toggleDropdown}
                >
                  &#x22EF; {/* Horizontal ellipsis */}
                </div>
                {dropdownVisible && (
                  <div class="absolute right-0 mt-2 w-40 border border-gray-300 rounded shadow-lg z-10">
                    <div
                      class="px-4 py-2 cursor-pointer bg-gray-600 hover:bg-gray-700"
                      onClick={() => handleDropdownAction('pin')}
                    >
                      {pinned ? (language === "ru" ? "Открепить в моей библиотеке" : "Unpin in my library") : (language === "ru" ? "Закрепить в моей библиотеке" : "Pin in my library")}
                    </div>
                    {/* <div
                      class="px-4 py-2 cursor-pointer bg-gray-600 hover:bg-gray-700"
                      onClick={() => handleDropdownAction('logbook')}
                    >
                      {language === "ru" ? "Журнал" : "Logbook"}
                    </div> */}
                    <div
                      class="px-4 py-2 cursor-pointer text-red-600 bg-gray-600 hover:bg-gray-700"
                      onClick={() => handleDropdownAction('remove')}
                    >
                      {language === "ru" ? "Удалить из моей библиотеки" : "Remove from my library"}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        }

        <div class="mx-auto w-auto flex flex-row pb-2 border-b border-gray-400 shadow max-w-xl">
        {!isDropdown &&
          <div>
            <Link to={"https://wowcontent.lol/arts/"+art.id} >
              <img class="object-cover rounded-t-lg h-auto min-w-20 w-20 md:min-w-20 md:w-20 rounded-none rounded-s-lg" src={art.thumbnailUrl} alt=""/>
            </Link>
            <div class="mt-1">
              <PlatformRatings art={art} />
            </div>
          </div>
        }
          <div class="w-full">
          {
            <div class="text-lg ml-2 md:ml-4">
              {
              (eventType !== "recommendation")
              ?
                <div class="flex text-sm text-white items-center mt-1">                
                  {
                  eventType === "like"
                  ?
                    <>
                      <Link to={`https://wowcontent.lol/users/${event.userID}/likes`}>
                        <img class="rounded-full aspect-square max-w-8 max-h-8" src={userInfo.avatarUrl}/>
                      </Link>
                      <div>                  
                          &nbsp;
                          <span class="font-bold">
                            {(myUser && myUser.myUserInfo.myUserId === event.userID) ? ("") : userInfo.name}
                          </span>
                        {/* <span class="font-bold">
                          &nbsp;{localizeKey('addedToTheirLib', language)}
                        </span> */}
                        <span class="font-bold">
                          {
                            (myUser && myUser.myUserInfo.myUserId === event.userID) ? 
                              (language === "ru" ? "обсуждение в моей библиотеке" : "discussion in my library") :
                              (language === "ru" ? ": обсуждение в библиотеке у пользователя" : ": discussion in user's library")
                          }
                          
                        </span>

                        <div class="px-1 hover:underline leading-none">
                          <Link class="text-sm text-gray-400" to={"https://wowcontent.lol/" + (eventType === "recommendation" ? "recommendations/" : "artEvents/") + event.id}>
                            {new Date(event.createdTime).toLocaleDateString(language, { month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' })}
                          </Link>
                        </div>
                      </div>
                    </>
                  :
                    <div class="font-bold">
                      {
                      eventType === "recommendationIncoming" 
                      ? 
                        (language === "ru" ? "Рекомендовали вам персонально" : "Recommended to you personally")
                      :
                        (language === "ru" ? "Вы рекомендовали персонально" : "You recommended personally")
                      }
                    </div>
                  }
                </div>
              :
                <div class="text-sm font-bold">
                  {language === "ru" ? "Персональная рекомендация" : "Personal recommendation"}
                </div>
              }

              <div class="flex items-center text-white text-base leading-none mt-1">
                <span>{'«' + localizeArt(art, language).name.trim() /*remove this trim eventually*/ + '»' + (art.year ? ` (${art.year})`: "")}</span>&#32;
              </div>            
            </div>
          }

            <div class="ml-2 md:ml-4 text-sm">
              {
                eventType === 'recommendation' &&
                (
                  myUser && misc.fromUser.id === myUser.myUserInfo.myUserId ? // myUser && is to allow non-logged-in which is unnecessary
                    <div class="flex items-center">
                      {localizeKey('toWhomRecommended', language)}:&nbsp;
                      <Link class="flex items-center" to={`/users/${misc.toUser.id}/likes`}>
                        <img class="rounded-full max-w-8 max-h-8" src={misc.toUser.avatarUrl}/>
                        &nbsp;
                        <span class="text-blue-500">
                          {misc.toUser.userName}
                        </span>
                      </Link>
                    </div>
                  :
                    <div class="flex items-center">
                      {localizeKey('byWhomRecommended', language)}:&nbsp;
                      <Link class="flex items-center" to={`/users/${misc.fromUser.id}/likes`}>
                        <img class="rounded-full max-w-8 max-h-8" src={misc.fromUser.avatarUrl}/>
                        &nbsp;
                        <span class="text-blue-500">
                          {misc.fromUser.userName}
                        </span>
                      </Link>
                    </div>
                )
              }
              {
                logbookDateTime && (
                  <div class="text-gray-400">
                    {art.category === 1
                      ? (language === "ru" ? "Последний просмотр: " : "Last watch time: ")
                      : art.category === 2
                      ? (language === "ru" ? "Последняя игра: " : "Last play time: ")
                      : art.category === 3
                      ? (language === "ru" ? "Последнее чтение: " : "Last read time: ")
                      : ""}
                    {logbookDateTime.getTime() === 0
                      ? (language === "ru" ? "Давно" : "Long time ago")
                      : logbookDateTime.toLocaleDateString(language, {
                          month: 'long',
                          day: 'numeric',
                          year: 'numeric',
                          hour: 'numeric',
                          minute: 'numeric',
                        })}
                  </div>
                )
              }
            </div>        

          {!isDropdown &&
            <div class="mt-2">
              {isRecommendation ? (
                <PeopleTags
                  tags={eventTags || []}
                  selectedTagId={selectedRecommendationUserTag ? selectedRecommendationUserTag.id : null}
                  onSelect={updatePersonalRecomChatId}
                  language={language}
                />
              ) : (
                <TagsInput 
                  key={eventId}
                  language={language} 
                  initFocus={tagsInitFocus} 
                  editable={eventType === "like" && myUser && myUser.myUserInfo.myUserId === event.userID}
                  initialTags={eventTags ? eventTags.map((eventTag) => { return eventTag.imgUrl ? eventTag.name + "\\" + eventTag.imgUrl : eventTag.name; }) : []} 
                  initialTagObjects={eventTags ? eventTags : []}
                  onTagsChange={(updatedTags) => {handleEventTag(eventId, updatedTags)}}
                />
              )}
            </div>
          }

          {/*
          <div class="mt-4 flex items-center">
            {
            (chatState === "shown" && myUser && event.userID === myUser.myUserInfo.myUserId) && // chatState check is a hack to check if it's single event page
              <div class="ml-4 text-red-600 hover:text-red-900 hover:cursor-pointer" onClick={() => {
                handleEventRemove(eventId);
              }}>
                {localizeKey('removeFromLib', language)}
              </div>  
            }
          </div>
          */}

          </div>
        </div>
        </div>
        {
        (chatState !== "hidden") &&
        <div class={chatFillHeight ? "flex-1 min-h-0" : ""}>
          {!isDropdown && false ?
            <Collapsible
              collapsed={chatState === "shown" ? false : /*collapsed*/ true }
              beforeTextImgUrl={selectedRecommendationUserTag ? selectedRecommendationUserTag.imgUrl : ""}
              buttonText={
                localizeKey(
                  eventType === 'recommendationIncoming' || eventType === 'recommendationOutgoing' ? 'privateChat' : 'chat',
                  language
                ) + " (" + eventChatInfo.messageCount + " " + localizeKey('messages', language) + ")"
              }
            >
              <MyChatComponent
                ref={chatComponentRef} // Attach ref to MyChatComponent
                key={eventChatId}
                chatId={eventChatId}
                _userChatInfo={eventChatInfo}
                language={language}
                myUserInfo={myUser ? myUser.myUserInfo : null}
                chatOwnerInfo={{type:eventType, id: event.id}}
              />
            </Collapsible>
          :
            <MyChatComponent
              ref={chatComponentRef} // Attach ref to MyChatComponent
              key={eventChatId}
              chatId={eventChatId}
              _userChatInfo={eventChatInfo}
              language={language}
              myUserInfo={myUser ? myUser.myUserInfo : null}
              chatOwnerInfo={{type:eventType, id: event.id}}
              isDropdown={false}
              fillHeight={chatFillHeight}
            />
        }
        </div>
        }
      </div>
    </>
  );
}

export default CardEventArtChat;
